import {
  Box,
  Grid,
  Table,
  TableContainer,
  Typography
} from "@mui/material";
import React from "react";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";

const infoTableCellSx = {
fontSize: 18,
};

export const Content = ({ screenMode, newsId, saveCondition, setSaveCondition, errors, validateData }) => {

  const handleChangeTitle = (e) => {
    setSaveCondition({...saveCondition, title: e.target.value})
  }

  const handleChangeContentText = (e) => {
    setSaveCondition({...saveCondition, contentText: e.target.value})
  }

  const handleBlurTitle = async () => {
    await validateData({ title: saveCondition.title }, 'title');
  };

  const handleBlurContentText = async () => {
    await validateData({ contentText: saveCondition.contentText }, 'contentText');
  };

  return (
    <TableContainer component={Box}>
      <Table>
        <TableBody>
          {screenMode === 2 && (
            <TableRow>
              <TableCell sx={{...infoTableCellSx, width: 200}}>
                <Grid container>
                  <Grid item xs="auto">
                    お知らせID
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell sx={ infoTableCellSx }>
                {newsId}
              </TableCell>
            </TableRow>
          )}
  
          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  タイトル&nbsp;
                </Grid>
                <Grid item xs="auto">
                  <Typography color="error">(必須)</Typography>
                </Grid>
              </Grid>
              {errors.title && <Typography sx={{ height: 25 }} />}
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs>
                  <TextField
                    sx={{ width: 500 }}
                    value={saveCondition.title}
                    onChange={handleChangeTitle}
                    onBlur={handleBlurTitle}
                    variant="outlined"
                    error={errors.title}
                  />
                </Grid>
              </Grid>
              {errors.title && (
                <Typography color="error" variant="caption" sx={{ marginTop: 1 }}>
                  {errors.title}
                </Typography>
              )}
            </TableCell>
          </TableRow>
  
          <TableRow>
            <TableCell sx={{...infoTableCellSx, width: 200}}>
              <Grid container>
                <Grid item xs="auto">
                  本文&nbsp;
                </Grid>
                <Grid item xs="auto">
                  <Typography color="error">(必須)</Typography>
                </Grid>
              </Grid>
              {errors.contentText && <Typography sx={{ height: 25 }} />}
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container direction="column">
                <Grid>
                  <TextField
                    sx={{ width: '100%' }}
                    value={saveCondition.contentText}
                    onChange={handleChangeContentText}
                    onBlur={handleBlurContentText}
                    multiline
                    rows={10}
                    variant="outlined"
                    error={errors.contentText}
                  />
                </Grid>
              </Grid>
              {errors.contentText &&(
                <Typography color="error" variant="caption">
                  {errors.contentText}
                </Typography>
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}